
const constants = {
  
  MENU_ITEMS: [
    {
      title: "Flight",
      link: "/FlightDoc",
      id: 1,
      pageId:null
    },
    {
      title: "Hotel",
      link: "/HotelDoc",
      id: 2,
      pageId:null
    },

    {
      title: "Bus",
      link: "/BusDoc",
      id: 3,
      pageId:null
    },
    {
      title: "Train",
      link: "/TrainDoc",
      id: 4,
      pageId:null
    }
  ],
  MENU_ITEMS_FLIGHT: [
    {
      title: "Search Api",
      link: "FlightSearchPage",
      id: 1,
      pageId:null
    },
    {
      title: "Detial Api",
      link: "FlightDetailPage",
      id: 2,
      pageId:null
    },

    {
      title: "Reserve Api",
      link: "FlightReservePage",
      id: 3,
      pageId:null
    },
    {
      title: "Issue Api",
      link: "FlightIssuePage",
      id: 4,
      pageId:null
    },
    {
      title: "Ticket Api",
      link: "FlightTicketPage",
      id: 5,
      pageId:null
    },
    {
      title: "Revalidate Api",
      link: "FlightRevalidatePage",
      id: 6,
      pageId:null
    },
    {
      title: "Cancel Api",
      link: "FlightCancelPage",
      id: 7,
      pageId: null
    },
    {
      title: "Refund By Ticket Api",
      link: "FlightRefundByTickets",
      id: 8,
      pageId: null
    }
    ,
    {
      title: "Refund By Refrence Api",
      link: "FlightRefundByRefrence",
      id: 9,
      pageId: null
    },
    {
      title: "Refund Status Api",
      link: "FlightRefundStatus",
      id: 10,
      pageId: null
    },
    {
      title: "Revalidate Api",
      link: "FlightRevalidate",
      id: 11,
      pageId: null
    },

  ],
  MENU_ITEMS_HOTEL: [
    {
      title: "Search Api",
      link: "HotelSearchPage",
      id: 1,
      pageId:null
    },
    {
      title: "Detial Api",
      link: "HotelDetailPage",
      id: 2,
      pageId:null
    },

    {
      title: "Reserve Api",
      link: "HotelReservePage",
      id: 3,
      pageId:null
    },
    {
      title: "Issue Api",
      link: "HotelIssuePage",
      id: 4,
      pageId:null
    }
    ,
    {
      title: "Ticket Api",
      link: "HotelTicketPage",
      id: 5,
      pageId:null
    },     
    {
      title: "Cancel Api",
      link: "HotelCancelPage",
      id: 6,
      pageId:null
    },
    {
      title: "Revalidate Api",
      link: "HotelRevalidatePage",
      id: 7,
      pageId:null
    }
  ],
  MENU_ITEMS_BUS: [
    {
      title: "Search Api",
      link: "BusSearchPage",
      id: 1,
      pageId: null
    },
    {
      title: "Reserve Api",
      link: "BusReservePage",
      id: 2,
      pageId: null
    },
    {
      title: "Issue Api",
      link: "BusIssuePage",
      id: 3,
      pageId: null
    }
    ,
    {
      title: "Ticket Api",
      link: "BusTicketPage",
      id: 4,
      pageId: null
    },
    {
      title: "Detail Api",
      link: "BusDetailPage",
      id: 5,
      pageId: null
    },
    {
      title: "Refund Api",
      link: "BusRefundPage",
      id: 6,
      pageId: null
    },
  ],
  MENU_ITEMS_TRAIN: [
    {
      title: "Search Api",
      link: "TrainSearchPage",
      id: 1,
      pageId: null
    },
    {
      title: "Reserve Api",
      link: "TrainReservePage",
      id: 2,
      pageId: null
    },
    {
      title: "Issue Api",
      link: "TrainIssuePage",
      id: 3,
      pageId: null
    }
    ,
    {
      title: "Ticket Api",
      link: "TrainTicketPage",
      id: 4,
      pageId: null
    },
    {
      title: "Cancel Api",
      link: "TrainCancelPage",
      id: 5,
      pageId: null
    },
  ],
};

export default constants;
